import React, { memo } from 'react';
import CustomImage from "components/CustomImage/CustomImage";
import moment from "moment";
import { serverTypeLorawanGateway } from "variables/MBM/lists/avobbox";

const numFmt = new Intl.NumberFormat();

export const InfoWindowContent = memo(({ features }) => {
    console.log(features);
    if (features.length === 1) {
        const f = features[0];
        const props = f.properties;

        return (
            <div style={{marginBottom: '10px'}}>
                <div class="bacsinfowindowimgcontainer">
                    <div className={"info-window-img"}>
                        {f.properties?.imageCode ? (
                            <CustomImage
                                imageCode={f.properties.imageCode}
                            />
                        ) :
                            (<></>
                            )

                        }
                    </div>
                </div>
                <div class='bacsinfotext'>{"Nom : " + f.properties.name}</div>
                <div class='bacsinfotext'>{"Description : " + (f.properties.description || '')}</div>
                <div class='bacsinfotext'>{"Dernière connexion : " + ((f.properties.lastconnection && moment(f.properties.lastconnection).isValid()) ? moment(f.properties.lastconnection).format("DD/MM/YYYY HH:mm:ss") : 'N/A')}</div>
                <div class='bacsinfotext'>{"Serveur : " + (f.properties.otherparameters?.servertype ? serverTypeLorawanGateway.find((x) => x.id == f.properties.otherparameters.servertype)?.name || "" : "")}</div>

            </div>
        );
    }

    return (
        <div style={{marginBottom: '10px'}}>
            <div class='bacsinfotext'>{numFmt.format(features.length) + ' passerelles : '}</div>
            {features.slice(0, 5).map(feature => {
                const props = feature.properties;

                return (
                    <div class='bacsinfotextgateways'>{props.name}  {" "} {props.status === 'ok' ?  "(connectée)" : props.status === 'ko'?  "(déconnectée)" : "(jamais connectée)"}</div>
                );
            })}

            {features.length > 5 && (
                <div class='bacsinfotextgateways'>...</div>
            )}
            <div class='bacsinfotext'>{"Connectée(s) : " + (features.filter((f)=>f.properties.status === 'ok').length)}</div>
            <div class='bacsinfotext'>{"Déconnectée(s) : " + (features.filter((f)=>f.properties.status === 'ko').length)}</div>
            <div class='bacsinfotext'>{"Jamais connectée(s) : " + (features.filter((f)=>f.properties.status === 'unknown').length)}</div>

        </div>
    );
});

